import React, { useState } from 'react';
import { teamAPI } from '../services/api';

const STATUTS = {
  nouveau:   { label: 'Nouveau',     color: '#2563eb', bg: 'rgba(37,99,235,0.12)' },
  confirme:  { label: 'Confirmé',     color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
  annule:    { label: 'Annulé',      color: '#ef4444', bg: 'rgba(239,68,68,0.10)' },
  rencontre: { label: 'Rencontre',    color: '#3b82f6', bg: 'rgba(59,130,246,0.10)' },
  no_show:   { label: 'No show',     color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  injoignable:{ label: 'Injoignable', color: '#f97316', bg: 'rgba(249,115,22,0.12)' },
  rdv2:      { label: '2ᵉ RDV',       color: '#a855f7', bg: 'rgba(168,85,247,0.12)' },
  refus:     { label: 'Refusé',      color: '#64748b', bg: 'rgba(100,116,139,0.12)' },
};

function fmtDate(d) {
  if (!d) return '—';
  try { return new Date(d.length === 10 ? d + 'T12:00:00' : d).toLocaleDateString('fr-CA', { day: '2-digit', month: 'short', weekday: 'short' }); } catch { return d; }
}
function fmtTime(t) { return t ? String(t).slice(0, 5) : '—'; }
function fmtDT(dt) {
  if (!dt) return '';
  try { return new Date(dt).toLocaleString('fr-CA', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }); }
  catch { return dt; }
}

const badge = (s) => {
  const m = STATUTS[s] || STATUTS.nouveau;
  return <span style={{ padding: '4px 12px', borderRadius: 100, fontSize: 12, fontWeight: 800, color: m.color, background: m.bg, border: `2px solid ${m.color}` }}>{m.label}</span>;
};

const inputStyle = { padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 14, width: '100%' };

export default function AppointmentDetail({ appointment, onClose, onUpdate }) {
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const [form, setForm] = useState({
    statut: appointment.statut,
    comments: appointment.comments || '',
    retour: appointment.retour || '',
    followup_at: appointment.followup_at ? String(appointment.followup_at).slice(0, 16).replace('T', ' ') : '',
  });

  const handleChange = (field, value) => setForm(f => ({ ...f, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true); setErr('');
    try {
      const payload = {
        statut: form.statut,
        comments: form.comments,
        retour: form.retour,
        followup_at: form.followup_at || null,
      };
      await teamAPI.updateAppointment(appointment.id, payload);
      onUpdate();
      onClose();
    } catch (e) {
      setErr(e?.error || 'Erreur lors de la sauvegarde');
    } finally { setSaving(false); }
  };

  const handleRetour = async (newStatut) => {
    let followup_at = null;
    let retour = form.retour;
    let payload = { statut: newStatut, retour, followup_at };

    if (newStatut === 'injoignable' || newStatut === 'rdv2') {
      const d = window.prompt(
        newStatut === 'injoignable'
          ? "Date du rappel par VOUS (AAAA-MM-JJ HH:MM, heure du Québec) :"
          : "Date du rappel par le CLIENT — 2ᵉ RDV (AAAA-MM-JJ HH:MM, heure du Québec) :", '');
      if (!d) return;
      followup_at = d;
      payload.followup_at = d;
      const note = window.prompt('Note (optionnel) :', retour) ?? retour;
      payload.retour = note;
    } else if (newStatut === 'no_show' || newStatut === 'rencontre' || newStatut === 'refus') {
      const msg = newStatut === 'rencontre' ? 'Résultat de la rencontre (optionnel) :'
        : newStatut === 'no_show' ? 'No show — note (optionnel) :'
        : 'Refus — note (optionnel) :';
      const note = window.prompt(msg, retour);
      if (note === null) return;
      retour = note;
      payload.retour = note;
    }

    try {
      setSaving(true);
      await teamAPI.retour(appointment.id, payload);
      onUpdate();
      onClose();
    } catch (e) { alert('Impossible : ' + (e?.error || e?.message)); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(30,18,72,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: '100%', maxWidth: 600, maxHeight: '90vh', overflow: 'auto', boxShadow: '0 24px 64px rgba(0,0,0,0.25)' }}
        onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, paddingBottom: 16, borderBottom: '1px solid #e2e8f0' }}>
          <div>
            <h2 style={{ fontSize: 20, fontWeight: 900, color: '#7c3aed', marginBottom: 4 }}>
              {[appointment.client_first, appointment.client_last].filter(Boolean).join(' ') || '—'}
            </h2>
            <div style={{ display: 'flex', gap: 16, fontSize: 13, color: '#64748b', flexWrap: 'wrap' }}>
              <span>📞 {appointment.phone || '—'}</span>
              <span>📅 {fmtDate(appointment.rdv_date)}</span>
              <span>🕐 {fmtTime(appointment.rdv_time)}</span>
              <span>{appointment.mode === 'virtuel' ? '💻 Virtuel' : appointment.mode === 'telephonique' ? '📞 Téléphonique' : '—'}</span>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ padding: '4px 12px', borderRadius: 100, fontSize: 12, fontWeight: 800, color: STATUTS[appointment.statut]?.color || '#2563eb', background: STATUTS[appointment.statut]?.bg || 'rgba(37,99,235,0.12)', border: `2px solid ${STATUTS[appointment.statut]?.color || '#2563eb'}` }}>{STATUTS[appointment.statut]?.label || appointment.statut}</span>
            <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#94a3b8', padding: 4, lineHeight: 1 }}>✕</button>
          </div>
        </div>

        {err && <div style={{ marginBottom: 16, padding: '10px 12px', background: 'rgba(239,68,68,0.1)', border: '1px solid #ef4444', borderRadius: 8, color: '#b91c1c', fontSize: 13, fontWeight: 600 }}>{err}</div>}

        <form onSubmit={handleSubmit}>
          {/* Statut */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 800, color: '#475569', marginBottom: 8 }}>Statut du rendez-vous</label>
            <select value={form.statut} onChange={e => handleChange('statut', e.target.value)} style={inputStyle}>
              {Object.entries(STATUTS).map(([k, m]) => <option key={k} value={k}>{m.label}</option>)}
            </select>
          </div>

          {/* Commentaires (agent) */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 800, color: '#475569', marginBottom: 8 }}>Commentaires (vos notes)</label>
            <textarea value={form.comments} onChange={e => handleChange('comments', e.target.value)} rows={3} style={inputStyle} placeholder="Notes internes…" />
          </div>

          {/* Retour / Note de suivi */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 800, color: '#0369a1', marginBottom: 8 }}>Note de suivi / Retour client</label>
            <textarea value={form.retour} onChange={e => handleChange('retour', e.target.value)} rows={3} style={inputStyle} placeholder="Note ajoutée après l'appel ou le rappel…" />
          </div>

          {/* Rappel (followup) */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 800, color: '#475569', marginBottom: 8 }}>Rappel programmé (AAAA-MM-JJ HH:MM, heure du Québec)</label>
            <input type="datetime-local" value={form.followup_at} onChange={e => handleChange('followup_at', e.target.value)} style={inputStyle} />
            <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Laisser vide si aucun rappel n'est prévu.</div>
          </div>

          {/* Quick action buttons */}
          <div style={{ marginBottom: 20, padding: 16, background: '#f8f7fc', borderRadius: 10, border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: '#475569', marginBottom: 10 }}>Actions rapides</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button type="button" onClick={() => handleRetour('rencontre')} style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #93c5fd', background: '#eff6ff', color: '#2563eb', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>✅ Marquer Rencontre</button>
              <button type="button" onClick={() => handleRetour('no_show')} style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #fcd34d', background: '#fffbeb', color: '#d97706', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>⚠️ No show</button>
              <button type="button" onClick={() => handleRetour('injoignable')} style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #fdba74', background: '#fff7ed', color: '#ea580c', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>📞 Injoignable → Je rappelle</button>
              <button type="button" onClick={() => handleRetour('rdv2')} style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #d8b4fe', background: '#faf5ff', color: '#9333ea', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>🔄 2ᵉ RDV → Client rappelle</button>
              <button type="button" onClick={() => handleRetour('refus')} style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #94a3b8', background: '#f1f5f9', color: '#475569', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>❌ Refus</button>
            </div>
          </div>

          {/* Submit buttons */}
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button type="button" onClick={onClose} style={{ padding: '12px 20px', borderRadius: 8, border: '1px solid #cbd5e1', background: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>Fermer</button>
            <button type="submit" disabled={saving} style={{ padding: '12px 20px', borderRadius: 8, border: 'none', background: '#7c3aed', color: '#fff', fontSize: 14, fontWeight: 800, cursor: saving ? 'not-allowed' : 'pointer' }}>
              {saving ? 'Sauvegarde…' : 'Sauvegarder'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}